/**
 * Identidad del comprobante de venta, con la misma regla que el backend
 * (identidadComprobanteVenta en backend/src/ventas/comprobante-venta.ts).
 */

/** Punto de venta y número: los dos o ninguno. Con cualquiera de los dos cargado, se piden ambos. */
export const pideNumeroComprobante = (puntoVenta: string, numero: string) => puntoVenta !== '' || numero !== '';
